export default __webpack_public_path__ + "static/media/cross-platform.b1d514bd.svg";